import $                 from 'jquery';
import React             from 'react';
import ReactDOM          from 'react-dom';
import Reflux            from 'reflux';
import ApiActionsFactory from './api/actions-factory';
import Api               from './api';
import Form              from './form';
import Utils             from 'medscape/utils';

const ApiStore = Api.store;
const validFormTypes = [1,3,16];
export default class QuestionnaireComponent extends Reflux.Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.store = ApiStore.get(props);
    this.ApiActions = ApiActionsFactory.get(`${props.qid}-${props.formId}`);
  }
  componentDidMount() {
    this.ApiActions.get(this.props.qid,this.props.formId);
  }
  componentDidUpdate() {
    $(window).trigger('scroll');
  }
  componentWillUnmount() {
    this.store.stopListeningToAll();
    Api.store.clearCache();
  }
  render() {
    if(this.state.qid==null) {
      return false;
    }
    const formTypeId = this.state.formTypeId;
    if(validFormTypes.indexOf(formTypeId)<0) {
      console.warn("QNA Form Type ID Not Implemented: ", formTypeId);
      return false;
    }
    let formProps = {
      questionnaire: this.state,
      questionNumberText: this.props.questionNumberText,
      flagRequired: this.props.flagRequired,
      configId: this.props.configId
    }
    // let title = this.props.title.length>0 ? this.props.title : this.state.formTitle;
    let title = this.props.title;
    if(title.length>0) {
      let titleProps = {
        dangerouslySetInnerHTML: Utils.getDangerousHtml(title)
      }
      return(
        <div className="questionnaire-component">
          <h1 {...titleProps}></h1>
          <div className="form-container">
            <Form {...formProps} />
          </div>
        </div>
      )
    } else {
      return(
        <div className="questionnaire-component">
          <div className="form-container">
            <Form {...formProps} />
          </div>
        </div>
      )
    }
  }
}
QuestionnaireComponent.propTypes={
  title: React.PropTypes.string,
  qid: React.PropTypes.string.isRequired,
  formId: React.PropTypes.string,
  questionNumberText: React.PropTypes.string,
  flagRequired: React.PropTypes.bool
}
QuestionnaireComponent.defaultProps={
  title: '',
  formId: '1',
  questionNumberText: '',
  flagRequired: false
}



// WEBPACK FOOTER //
// ./medscape_modules/qna/app.jsx